import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { IPublish } from '../../review-management.interfaces';

@Component({
  selector: 'app-success-popup',
  templateUrl: './success-popup.component.html',
  styleUrls: ['./success-popup.component.scss'],
})
export class SuccessPopupComponent implements OnInit {
  publishObject: IPublish<any> & { customContent?: string; message?: string };
  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private dialogService: DialogService
  ) {}

  /**
   * Initializes popup payload and optional custom success text from dialog data.
   * Uses provided `customContent` as an override message when available.
   * @returns None.
   */
  ngOnInit(): void {
    this.publishObject = (this.dynamicDialogConfig?.data ?? {}) as IPublish<any> & {
      customContent?: string;
      message?: string;
    };
  }

  closeSuccessPopup() {
    this.ref.close();
  }
}
